import { registerConsentEffect } from "../../cookie-consent-registry";

registerConsentEffect("publicidade", {
  onGrant: () => {
    window.gtag?.("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });

    window?.dataLayer?.push({
      event: "consent_update",
    });
  },

  onDeny: () => {
    window.gtag?.("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });

    window?.dataLayer?.push({
      event: "consent_update",
    });
  },
});
